var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { padStart, toString } from 'lodash';
export var ItemNumberDefaultProps = {
  padToLength: 2
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    border: 2px solid ", ";\n    background: ", ";\n    border-radius: 50%;\n    height: ", ";\n    width: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;    \n    color: ", ";\n    font-weight: 500;\n  "], ["\n    font-size: ", ";\n    border: 2px solid ", ";\n    background: ", ";\n    border-radius: 50%;\n    height: ", ";\n    width: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;    \n    color: ", ";\n    font-weight: 500;\n  "])), theme.FONT_SIZE(20), theme.COLOR('strong'), theme.COLOR('light'), theme.UNIT(10), theme.UNIT(10), theme.COLOR('strong'))
});
// -------- Components -------->
var My = {
  Container: styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var ItemNumber = function (props) {
  var className = props.className,
    children = props.children,
    value = props.value,
    padToLength = props.padToLength;
  return React.createElement(My.Container, {
    className: className
  }, padStart(toString(value), padToLength, '0'));
};
ItemNumber.defaultProps = ItemNumberDefaultProps;
var templateObject_1, templateObject_2;